import clsx from 'clsx'
import { useEffect, useState } from 'react'
import getTestId from 'utils/getTestId'

import style from './UserAvatar.module.css'

export function userInitials(firstName?: string | null, lastName?: string | null, email?: string | null): string {
  const fromName = [firstName?.charAt(0), lastName?.charAt(0)].filter(Boolean).join('').toUpperCase()
  if (fromName) return fromName
  return (email || '').substring(0, 2).toUpperCase()
}

type Props = {
  url?: string | null
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  size?: number
  className?: string
  testId?: string
}

const UserAvatar = ({ url, firstName, lastName, email, size = 36, className, testId }: Props) => {
  const [broken, setBroken] = useState(false)
  useEffect(() => {
    setBroken(false)
  }, [url])
  const initials = userInitials(firstName, lastName, email)
  const showPhoto = Boolean(url) && !broken

  return (
    <span
      className={clsx(style.root, className)}
      style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.38)) }}
      data-test-id={testId || getTestId('user-avatar-face')}
    >
      {showPhoto ? (
        <img
          src={url || ''}
          alt=""
          className={style.image}
          onError={() => setBroken(true)}
        />
      ) : (
        <span className={style.initials} data-test-id={getTestId('avatar-text')}>
          {initials}
        </span>
      )}
    </span>
  )
}

export default UserAvatar
